<template>
<div class="wholeBread">
  <div class="breadBox">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="projSearch--breadcrumb" >
      <el-breadcrumb-item 
        v-for="(item, index) in displayBreadcrumbs" 
        :key="index"
        :to="item.path ? { name: item.path } : null"
        :class="{ 'is-last': index === displayBreadcrumbs.length - 1 }"
      >
        <span :style="getBreadcrumbTextStyle(item, index)">
          <font-awesome-icon v-if="item.icon" :icon="item.icon" style="margin-right:8px;" />
          {{ item.name }}
        </span>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <hr/>
  </div>
</div>  
</template>

<script>
export default {
  props: {
    breadcrumbs: {
      type: Array,
      required: false,
      default: () => [{ name: '首頁', icon: 'home', path: 'home' }],
      validator: (breadcrumbs) => {
        // 宽松的验证：允许空数组，每个元素必须有 name 属性
        if (!Array.isArray(breadcrumbs)) {
          return false;
        }
        return breadcrumbs.every(item => 
          item && typeof item === 'object' && item.hasOwnProperty('name')
        );
      }
    },
  },
  computed: {
    // 過濾掉「首頁」項目
    displayBreadcrumbs() {
      return this.breadcrumbs.filter(item => item.name !== '首頁');
    }
  },
  methods: {
    getBreadcrumbTextStyle(item, index) {
      const isLast = index === this.displayBreadcrumbs.length - 1;
      if (item && item.path && !isLast) {
        return {
          textDecoration: 'underline',
          fontWeight: '400',
        };
      }
      return {};
    }
  },
};
</script>

<style lang="scss" scoped>
.wholeBread {
    display: flex;
    width: 100%;
    justify-content: center;

  .breadBox {
    display: flex;
    width: 90%;
    flex-direction: column;
    align-items: flex-start;

    .projSearch {
      &--breadcrumb {
        padding: 20px 0px;

        /* 非最後一項視為可返回連結：改為底線並取消粗體 */
        :deep(.el-breadcrumb__item:not(:last-child) .el-breadcrumb__inner) {
          font-weight: 400 !important;
          text-decoration: underline !important;
        }

        :deep(.el-breadcrumb__item:not(:last-child) .el-breadcrumb__inner:hover) {
          text-decoration: underline !important;
        }
        
        /* 最后一项不可点击样式 */
        :deep(.el-breadcrumb__item:last-child) {
          color: #E0652A;
          cursor: default;
          
          a {
            color: inherit;
            cursor: default;
            
            &:hover {
              color: inherit;
            }
          }
        }
      }
    }

    hr {
      border: 2px solid #E0652A;
      border-radius: 5px;
      filter: drop-shadow(2px 2px 1px #aaa);
      width: 100%;
      margin-bottom: 2%;
    }  

  }

}
</style>
